import { Country } from "../../model/Country";

export function initEmptyModel() {
  var broker = {
    id: '',
    languageId: '',
    dataLayerId: '',
    name: '',
    isActive: false,
    foundation: '',
    isGoldenPartner: false,
    description: '',
    address: {
      fullAddress: '',
      headQuarters: ''
    },
    url: '',
    reviewUrl: '',
    imageUrl: '',
    freeDemoUrl: '',
    demoAccountDescription: '',
    liveAccountUrl: '',
    termsAndConditionsUrl: '',
    totalPairsOffered: '',
    pairsUrl: '',
    scalpingAllowed: false,
    swapFreeAcounts: false,
    swapFreeAccountsInfo: '',
    pamm: false,
    pammPolicyUrl: '',
    hasComissions: false,
    comissionsDescription: '',
    disclosureMessage: '',
    leverageDescription: '',
    contactInformation: {
      name: '',
      phone: '',
      email: '',
      websiteUrl: '',
      faqUrl: '',
      customerServiceUrl: '',
      leadContact:''
    },
    accountTypes: [],
    promotions: [],
    educationPrograms: [],
    platforms: [],
    accountCurrencies: [],
    languages: [],
    lotSizes: [],
    paymentMethods: [],
    instruments: [],
    regulations: [],
    businessNature: [],
    bannedCountries: [],
    isCrypto: false,
    isForex: false,
    showcaseOpenAccountUrl: '',
    inListing: true
  };
  return broker;
}

export function mapToTagModelArray(source: string[]): any[] {
  var result = null;
  if (source != null) {
    result = source.map(item => ({
      value: item,
      display: item
    }));
  }
  return result;
}

export function mapToBannedCountryTagModelArray(source: string[], countries: any[]): any[] {
  var result = null;
  if (source != null) {
    result = countries.filter(item => source.includes(item.value));
  }
  return result;
}

export function mapToCountryTagModelArray(source: Country[]): any[] {
  var result = null;
  if (source != null) {
    result = source.map(item => ({
      value: item.code,
      display: item.name
    }));
  }
  return result;
}

export function mapToStringArray(source: any[]): string[] {
  var result: string[] = [];
  if (source != null) {
    result = source.map(item => item.value);
  }
  return result;
}

export function isNullOrEmpty(value: string | null | undefined): boolean {
  return value === null || value === undefined || value.trim().length === 0;
}



// WEBPACK FOOTER //
// ./src/app/brokers/components/scripts/broker-model-utils.ts